// Tryby rejestrów biura podawczego (port „Rejestry" z Magistratu) — wspólne dla
// komponentu MailroomRegister i modułu /registry (tytuły paneli).

export type MailroomRegisterMode =
  | "incoming"
  | "outgoing"
  | "internal"
  | "fees"
  | "archive";

export const MAILROOM_REGISTER_TITLES: Record<MailroomRegisterMode, string> = {
  incoming: "Przesyłki przychodzące",
  outgoing: "Przesyłki wychodzące",
  internal: "Dokumenty wewnętrzne",
  fees: "Rozliczenia opłat pocztowych",
  archive: "Archiwum przesyłek",
};
